export default __webpack_public_path__ + "264a58344ef87716795cf3aef8e0be2a.svg";